import { AutomaticAssessmentDataTypes } from './types';

import axiosInstance from 'services/common/instance';

const getAutomaticAssessmentService = async (
  stockSymbol: string,
): Promise<AutomaticAssessmentDataTypes> => {
  const res = await axiosInstance.get(`ttpt-automatic-assessments/${stockSymbol}`);
  return res.data.data;
};

export default getAutomaticAssessmentService;
